import { render, staticRenderFns } from "./HeaderDesktopMenu.vue?vue&type=template&id=5089788e&scoped=true"
import script from "./HeaderDesktopMenu.vue?vue&type=script&lang=js"
export * from "./HeaderDesktopMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderDesktopMenu.vue?vue&type=style&index=0&id=5089788e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089788e",
  null
  
)

export default component.exports